import { useMutation, useQuery } from '@tanstack/react-query'
import {
  GtmDemoRequestError,
  createGtmDemoRun,
  fetchGtmDemoRun,
} from '@/features/gtm/api/gtm-demo-api'
import { isGtmDemoRunInProgress } from '@/features/gtm/domain/gtm-demo-view'

const POLL_INTERVAL_MS = 2000

export const gtmDemoKeys = {
  all: ['gtm', 'demo-run'] as const,
  run: (id: string) => [...gtmDemoKeys.all, id] as const,
}

export function useCreateGtmDemoRunMutation() {
  return useMutation({
    mutationKey: ['gtm', 'create-demo-run'],
    mutationFn: (url: string) => createGtmDemoRun(url),
  })
}

export function useGtmDemoRunQuery(runId: string | undefined) {
  return useQuery({
    queryKey: gtmDemoKeys.run(runId ?? ''),
    queryFn: () => fetchGtmDemoRun(runId ?? ''),
    enabled: Boolean(runId),
    // A run takes 20–60s; poll until it settles, then stop for good.
    refetchInterval: (query) =>
      isGtmDemoRunInProgress(query.state.data) ? POLL_INTERVAL_MS : false,
    refetchOnWindowFocus: false,
    // Known API answers (expired id, disabled demo) are final; retry blips.
    retry: (failureCount, error) =>
      !(error instanceof GtmDemoRequestError) || error.key === 'internal'
        ? failureCount < 2
        : false,
  })
}
